import { defineMessages } from 'react-intl'

export default defineMessages({
  timeAndDateHeader: {
    id: 'app.timeAndDate.headline',
    defaultMessage: 'Time and Date',
  },
  timeAndDatePlaceholderDate: {
    id: 'app.timeAndDate.placeholder.date',
    defaultMessage: 'Pick a date',
  },
  timeAndDatePlaceholderTime: {
    id: 'app.timeAndDate.placeholder.time',
    defaultMessage: 'Pick a time',
  },
  timeAndDateValidationDate: {
    id: 'app.timeAndDate.validation.date',
    defaultMessage: 'Please select a date!',
  },
  timeAndDateValidationTime: {
    id: 'app.timeAndDate.validation.time',
    defaultMessage: 'Please select a time!',
  },
  claimsFillOutTheForm: {
    id: 'app.claims.claimType.form',
    defaultMessage: 'Fill out the form',
  },
})
